<template>
  <div class="search_container">
    <div class="search_header">
      <span class="search_title">选择班级</span>
      <img class="btn_close" src="https://image.xiaomaiketang.com/xm/HFYSBYmf2C.png" @click="cancel" />
    </div>
    <div class="search_body">
      <yd-search v-model="searchValue" @input="debounceSearch" placeholder="搜索班级名称" :on-cancel="handleCancel"></yd-search>
      <!-- distance="30" v-infinite-scroll="scrollLoad" :loading="loading" -->
      <div class="search_result">
        <xm-scroll v-if="recordList.length > 0" :on-infinite="scrollLoad" :enableInfinite="canLoad">
          <div class="result_list" style="margin-bottom:1.6rem">
            <div class="result_item" v-for="(item, index) in recordList" :key="index" @click="handleSelectClass(item.classId)">
              <div class="item_left">
                <div class="class_title">{{ item.className }}</div>
                <div class="remain_number">剩余名额: {{ renderRemain(item) }}</div>
                <div class="teacher_name">上课老师: {{ renderTeacher(item) }}</div>
              </div>
              <div class="item_right">
                <img v-show="selectedClassId === item.classId" src="https://image.xiaomaiketang.com/xm/HH875kSC8B.png" />
              </div>
              <div v-if="item.studentInClass" class="status">已在班级</div>
            </div>
          </div>
        </xm-scroll>
        <!-- https://image.xiaomaiketang.com/xm/zQwsWR6ww2.png 课程暂未设置班级-->
        <!-- https://image.xiaomaiketang.com/xm/JypYkCQChP.png 没有搜索的班级-->
        <xm-empty-page :src="emptyPageOpt.src" :title="emptyPageOpt.title" v-if="!recordList.length" />
      </div>
    </div>
    <div class="search_footer">
      <button v-if="recordList.length" class="btn_cancel" @click="handleClear">暂不选班</button>
      <button class="btn_confirm" @click="confirm" :style="{ width: recordList.length ? '3.2rem' : '100%' }">确定</button>
    </div>
  </div>
</template>
<script>
import EmptyDataPage from '@/module/base/EmptyDataPage';
import { boolean } from 'mathjs';

const EmptyEnum = {
  notSet: {
    src: 'https://image.xiaomaiketang.com/xm/zQwsWR6ww2.png',
    title: '课程暂未设置班级',
    toastTitle: '无关联班级',
  },
  notSet_required: {
    src: 'https://image.xiaomaiketang.com/xm/zQwsWR6ww2.png',
    title: '课程暂未设置班级，请联系机构老师',
    toastTitle: '无关联班级',
  },
  notFound: {
    src: 'https://image.xiaomaiketang.com/xm/JypYkCQChP.png',
    title: '没有搜索的班级',
    toastTitle: '请选择班级',
  },
};

export default {
  components: {
    'xm-empty-page': EmptyDataPage,
  },
  props: {
    courseId: {
      type: String,
      default: '',
    },
    studentId: {
      type: String,
      default: '',
    },
    classId: {
      type: String,
      default: '',
    },
    require: {
      type: String,
      default: '',
    },
  },
  computed: {
    emptyPageOpt() {
      return EmptyEnum[this.emptyType];
    },
  },
  data() {
    return {
      emptyType: 'notSet',
      searchValue: '',
      canLoad: false, // 是否还可以加载数据
      current: 1,
      size: 10,
      lastId: void 0,
      teacherId: '',
      selectedClassId: this.classId,
      recordList: [],
      loading: false,
      debounceSearch: () => {},
    };
  },
  mounted() {
    this.handleSearch();
    this.debounceSearch = _.debounce(() => {
      this.handleSearch('input');
    }, 500);
  },
  methods: {
    handleSearch(type) {
      const { courseId, studentId, lastId, teacherId, searchValue, current, size } = this;
      const url = 'public/instClass/queryOnlineSelectClass';
      const params = {
        classNameLike: searchValue,
        courseId,
        current: type === 'input' ? 1 : current,
        instId: window.getParameterByName('instId'),
        lastId: type === 'input' ? void 0 : lastId,
        size,
        studentId,
        teacherId,
      };

      return axios.Customer(url, params).then(res => {
        const { records = [] } = res.result;
        const data = this.recordList.length > 0 ? this.recordList : [];
        const _recordList = type === 'input' ? records : data.concat(records);
        const len = records.length;

        this.canLoad = false;

        if (!_recordList.length) {
          if (searchValue) {
            this.emptyType = 'notFound';
          } else {
            if (this.require === 'require') {
              this.emptyType = 'notSet_required';
            } else {
              this.emptyType = 'notSet';
            }
          }
        }
        if (len >= 10) {
          this.lastId = records[len - 1].classId;
          this.canLoad = true;
        }

        this.recordList = _recordList;
      });
    },
    // 下拉加载
    scrollLoad(done) {
      if (!this.canLoad || this.recordList.length === 0) return;
      this.loading = true;
      this.current = this.current + 1;
      this.handleSearch().then(() => {
        this.loading = false;
        done && done();
      });
    },
    // 清空搜索条件
    handleCancel() {
      this.searchValue = '';
      this.handleSearch();
    },
    handleSelectClass(classId) {
      this.selectedClassId = this.selectedClassId === classId ? void 0 : classId;
    },
    // 渲染【剩余名额】
    renderRemain(item) {
      const { capacity, studentNum = 0, allowOverflow } = item;

      if (allowOverflow) {
        return '不限名额';
      }
      return `${capacity - studentNum}人`;
    },
    // 渲染【上课老师】
    renderTeacher(item) {
      const { digestTeachers = [] } = item;
      const len = digestTeachers.length;
      let str;

      if (len) {
        if (len > 1) {
          str = `${digestTeachers[0].teacherName}等${len}人`;
        } else {
          str = digestTeachers[0].teacherName;
        }
      } else {
        str = '暂无';
      }
      return str;
    },
    // 暂不选班
    handleClear() {
      this.$emit('confirm', {});
      this.cancel();
    },
    // 关闭弹窗
    cancel() {
      this.$emit('cancel');
    },
    // 确认选班
    confirm() {
      if (this.selectedClassId) {
        const { classId, className } = this.recordList.find(item => {
          return item.classId === this.selectedClassId;
        });

        this.$emit('confirm', { className, classId });
        this.cancel();
      } else {
        if (this.recordList.length) {
          Vue.$wheatToast('请选择班级');
        } else {
          Vue.$wheatToast(this.emptyPageOpt.toastTitle);
        }
      }
    },
  },
};
</script>
<style lang="less">
@import '../../core/mixins.less';

.yd-popup {
  border-top-left-radius: 0.2rem;
  border-top-right-radius: 0.2rem;
  .yd-popup-content {
    & > div {
      height: 100%;
      .search_container {
        display: flex;
        flex-direction: column;
        position: relative;
        height: 100%;
        overflow: hidden;
        .search_header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 0.24rem 0.32rem;
          .btn_close {
            width: 0.42rem;
            height: 0.42rem;
          }
        }
        .search_body {
          display: flex;
          flex-direction: column;
          height: 100%;
          .yd-search {
            .yd-search-input {
              background: #ffffff;
              .search-input {
                background: #f7f7f7;
              }
            }
            .-text {
              color: #999;
            }
          }
          .search_result {
            position: relative;
            height: 100%;
            // margin-bottom: 2rem;
            overflow: auto;
            .scroll-inner {
              top: 0;
            }
            .result_list {
              height: 100%;
              .result_item {
                position: relative;
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding: 0.24rem 0.32rem;
                text-align: left;
                border-bottom: 1px solid #eee;
                .item_left {
                  .class_title {
                    width: 100%;
                    font-size: 0.32rem;
                    font-weight: bold;
                    .text-overflow-ellipsis-line(2);
                  }
                  .remain_number,
                  .teacher_name {
                    margin-top: 0.14rem;
                    font-size: 0.3rem;
                    color: #999;
                  }
                }
                .item_right {
                  position: relative;
                  text-align: right;
                  flex: 0 0 3rem;
                  img {
                    width: 0.32rem;
                    height: 0.32rem;
                  }
                }
                .status {
                  position: absolute;
                  width: 1.5rem;
                  text-align: center;
                  bottom: 0.3rem;
                  right: 0.1rem;
                  color: #ff6934;
                  font-size: 0.26rem;
                }
              }
            }
            .empty-data-page {
              background: #ffffff;
            }
          }
        }
        .search_footer {
          position: fixed;
          bottom: 0;
          left: 0;
          width: 100%;
          padding: 0.24rem 0.38rem;
          display: flex;
          align-items: center;
          justify-content: space-between;
          background: #ffffff;
          button {
            width: 3.2rem;
            height: 1.05rem;
            line-height: 1.05rem;
            font-size: 0.3rem;
            border-radius: 5px;
            border: 0 none;
          }
          .btn_cancel {
            color: #ff6934;
            border: 1px solid #ff6934;
          }
          .btn_confirm {
            color: #ffffff;
            background-image: linear-gradient(to right, #ff7819, #ff4200);
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/module/mall/AddClass.vue